import initialState from './initialstate';
import * as types from '../Actions/actiontypes';
import {engagementAccessTypeEnum} from '../../../../util/uiconstants';
/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function GetHandoffReducer(state = initialState.handoff, action) {
	switch (action.type) {
		case types.HO_GET_HAND_OFF_USERS: {
			return action.response;
		}
		default:
			return state;
	}
}
